<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="450"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="名称：" prop="name">
                            <Input v-model="Forms.name" placeholder="名称" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="排序：" prop="sort">
                            <Input v-model="Forms.sort" placeholder="默认ID" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="状态：">
                            <RadioGroup v-model="Forms.status">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {saveCompanyBusiness, getCompanyBusinessDetail} from "@/apis/company";

export default {
    name: 'CompanyBusinessCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增产品',
            isBox : false,
            parentList : [],
            Forms : {
                b_id:'',
                name: '',
                sort: '',
                status: 3
            },
            Rules : {
                name: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        /**
         功能：获取详情
         time: 2025-53-02 10:53:04
         **/
        GetDetail(b_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getCompanyBusinessDetail(b_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    that.Forms[v] = data[v];
                    if(v === 'status' ) {
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：添加
         time: 2025-52-02 10:52:34
         **/
        add(){
            this.isBox = true;
        },
        /**
         功能：编辑
         time: 2025-52-02 10:52:42
         **/
        edit(b_id){
            this.isBox = true;
            this.title = '编辑产品';
            if(b_id) this.GetDetail(b_id);
        },
        /**
         功能：
         time: 2025-55-02 10:55:40
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveCompanyBusiness(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025-55-02 10:55:45
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增产品';
            this.$refs['Forms'].resetFields();
            this.Forms.b_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
